module.exports = __webpack_public_path__ + "05_face.47f872b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/05_face.png
// module id = fUXs
// module chunks = 0